<app-dialog>
  <ng-container dialog-content>
    <div class="general-error-modal-container">
      <span class="fa fa-exclamation-circle warning-exclamation-circle"></span>
      <p>{{ descriptionText }}</p>
    </div>
  </ng-container>
</app-dialog>
